import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

  useEffect(() => {
    let timeout;
    const handler = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsMobile(window.innerWidth < breakpoint), 150);
    };
    window.addEventListener('resize', handler);
    return () => { clearTimeout(timeout); window.removeEventListener('resize', handler); };
  }, [breakpoint]);

  return isMobile;
}
